import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-page-not-found',
    template: `
        <h2 *ngIf="!resultsError">Sorry, this page doesn't exist!</h2>
        <h2 *ngIf="resultsError">No results found</h2>
    `,
    styles: [],
})
export class PageNotFoundComponent implements OnInit {
    resultsError: boolean = false;

    constructor(private _router: Router) {}

    ngOnInit() {
        var url = this._router.url;
        if (url.match('loanDetails/[1-9]+')) {
            this.resultsError = true;
        }
    }
}
